import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAWithoutMachineOperation } from "./types";

export const paOTWithoutMachineOperationListService = (params: {
  page?: number;
  limit?: number;
  status?: number;
  startDate?: string;
  endDate?: string;
  empCodes?: string[];
  empIds?: number[];
  transactionType?: string;
  workShiftCodes?: string[];
  machineIds?: string[];
  machineGroupIds?: string[];
  machineGroupCodes?: string[];
  productIds?: string[];
  productCodes?: string[];
  transactionTypes?: string[];
}) =>
  RestAPIClient.call<RestAPIResponseList<PAWithoutMachineOperation>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paOTWithoutMachineOperationImportService = (params: {
  startDate: string;
  endDate: string;
  items: {
    date: string;
    empCode: string;
    workShiftCode: string;
    transactionType: string;
    task: string;
    fromTime: string;
    toTime: string;
    leadTime: string;
    syncId: null;
  }[];
  empCodes: string[];
  workShiftCodes: string[];
}) =>
  RestAPIClient.call<PAWithoutMachineOperation>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paOTWithoutMachineOperationSyncService = (params: {
  fromDate: string;
  toDate: string;
}) =>
  RestAPIClient.call<PAWithoutMachineOperation>({
    method: HTTPRequestMethods.POST,
    url: Paths.Sync,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });
